import { createContext } from 'react'

// The next-step forms opened inside a tension. The state lives above both the
// activity stream and the composer, because the two are siblings: the button
// sits in the composer's bar, while the forms belong to the STREAM — a next
// step is an element of the tension, like its meeting note, not an annex of
// the message box (Yohan, 10/08/2026).
export interface NextStepFormsState {
  forms: number[]
  addForm(): void
  removeForm(key: number): void
}

export const NextStepFormsContext = createContext<
  NextStepFormsState | undefined
>(undefined)
